import Navigation from '../components/nav';
import Aboutcomponent from "../components/About/Aboutcomponent";


export default function About() {

  
  return (
    <>
    <Navigation />

    <Aboutcomponent />
    </>

  );
}


